import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { actions } from "../qr/qrSlice"

type Position = {
  x: number
  y: number
}

type Size = {
  width: number
  height: number
}

interface InvitationState {
  inviteName: string | null
  uploadedImage: string | null
  numberOutSideToggle: boolean
  removeLogo: boolean
  fontType: string
  qrColorCode: string
  showQrSize: boolean
  imageId: number
  eventId: number
  qrPosition: Position
  logoPosition: Position
  qrSize: Size
  inviteImageBinary?: any
  qrCodeDesignResponse?: any
  currentCreatedEvent?: any
  chooseType?: string | null
  contacts?: any | null
}

const initialState: InvitationState = {
  inviteName: null,
  uploadedImage: null,
  numberOutSideToggle: false,
  removeLogo: false,
  fontType: "Noto Sans",
  qrColorCode: "#ffffff",
  showQrSize: false,
  imageId: 0,
  eventId: 0,
  qrPosition: { x: 5, y: 2 },
  logoPosition: { x: 100, y: 2 },
  qrSize: { width: 60, height: 60 },
  inviteImageBinary: null,
  qrCodeDesignResponse: null,
  currentCreatedEvent: null,
  chooseType: "number",
  contacts: null,
}

const invitationSlice = createSlice({
  name: "invitation",
  initialState,
  reducers: {
    setInviteName(state, action: PayloadAction<string | null>) {
      state.inviteName = action.payload
    },

    setUploadedImage(state, action: PayloadAction<string | null>) {
      state.uploadedImage = action.payload
    },

    setSetCurrentCreatedEvent(state, action: PayloadAction<string | null>) {
      state.currentCreatedEvent = action.payload
    },

    setInviteImageBinary(state, action: PayloadAction<any | null>) {
      state.inviteImageBinary = action.payload
    },
    toggleNumberOutside(state) {
      state.numberOutSideToggle = !state.numberOutSideToggle
    },

    toggleRemoveLogo(state) {
      state.removeLogo = !state.removeLogo
    },

    setFontType(state, action: PayloadAction<string>) {
      state.fontType = action.payload
    },
    setQrColorCode(state, action: PayloadAction<string>) {
      state.qrColorCode = action.payload
    },
    toggleShowQrSize(state) {
      state.showQrSize = !state.showQrSize
    },
    setImageId(state, action: PayloadAction<number>) {
      state.imageId = action.payload
    },
    setEventId(state, action: PayloadAction<number>) {
      state.eventId = action.payload
    },
    setQrPosition(state, action: PayloadAction<Position>) {
      state.qrPosition = action.payload
    },
    setLogoPosition(state, action: PayloadAction<Position>) {
      state.logoPosition = action.payload
    },
    setQrSize(state, action: PayloadAction<Size>) {
      state.qrSize = action.payload
    },
    setQrCodeDesignResponse(state, action: PayloadAction<any | null>) {
      state.qrCodeDesignResponse = action.payload
    },

    setChooseType(state, action: PayloadAction<string | null>) {
      state.chooseType = action.payload
    },
    resetInvitationState() {
      return initialState
    },
  },
})

export const {
  setUploadedImage,
  toggleNumberOutside,
  toggleRemoveLogo,
  setFontType,
  setQrColorCode,
  toggleShowQrSize,
  setImageId,
  setEventId,
  setQrPosition,
  setLogoPosition,
  setQrSize,
  setInviteImageBinary,
  setQrCodeDesignResponse,
  setInviteName,
  setSetCurrentCreatedEvent,
  setChooseType,
  resetInvitationState,
} = invitationSlice.actions

export default invitationSlice.reducer
